import axios from 'axios';

const baseURL = 'https://api.victory-garage.com/api/';
// const baseURL = 'http://victorygarage.test/api/';

let api = axios.create({
  baseURL
})

export { api, baseURL }



// WEBPACK FOOTER //
// ./src/axios/index.js